import styled from '@emotion/styled'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[1]};
  margin: 0 auto;
  padding: 1rem 0 2rem 0;
`

const ChartContainer = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>
}

export default ChartContainer
